"use client";

import { useEffect, useState } from "react";
import { get } from "@/lib/api";
import { Button } from "./ui/Button";

const STATE_KEY = "icgak.kakaoState";

export function kakaoRedirectUri() {
  return `${window.location.origin}/auth/kakao/callback`;
}

export function takeKakaoState(): string | null {
  try {
    const v = window.sessionStorage.getItem(STATE_KEY);
    window.sessionStorage.removeItem(STATE_KEY);
    return v;
  } catch {
    return null;
  }
}

interface Providers {
  kakao: { enabled: boolean; clientId?: string };
}

/** 카카오 로그인 버튼. 백엔드에 키가 없으면 비활성으로 보인다. 로그인과 가입이 같은 흐름이다. */
export function KakaoButton({ label = "카카오로 계속하기" }: { label?: string }) {
  const [clientId, setClientId] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    get<Providers>("/v1/auth/providers")
      .then((p) => setClientId(p.kakao.enabled ? (p.kakao.clientId ?? null) : null))
      .catch(() => setClientId(null));
  }, []);

  const start = () => {
    if (!clientId) return;
    const state = crypto.randomUUID();
    try {
      window.sessionStorage.setItem(STATE_KEY, state);
    } catch {
      /* 세션 저장소가 막혀 있으면 state 검증 없이 진행 */
    }
    const q = new URLSearchParams({
      client_id: clientId,
      redirect_uri: kakaoRedirectUri(),
      response_type: "code",
      state,
    });
    window.location.href = `https://kauth.kakao.com/oauth/authorize?${q.toString()}`;
  };

  const disabled = clientId === null;
  return (
    <div className="flex flex-col gap-1.5">
      <Button variant="kakao" size="lg" block onClick={start} disabled={disabled} loading={clientId === undefined}>
        <svg viewBox="0 0 24 24" className="size-5" aria-hidden="true">
          <path
            fill="#000000"
            d="M12 3.6c-5.2 0-9.4 3.3-9.4 7.4 0 2.6 1.7 4.9 4.3 6.2l-1.1 4c-.1.3.3.6.6.4l4.7-3.1c.3 0 .6.1.9.1 5.2 0 9.4-3.3 9.4-7.4S17.2 3.6 12 3.6z"
          />
        </svg>
        {label}
      </Button>
      {disabled && <p className="text-center text-xs text-gray-500">카카오 로그인은 준비 중입니다.</p>}
    </div>
  );
}
